import { Button, Col, Row } from "antd"
import MibTerminalsMultiselect from "../../../../common/terminalPickers/MibTerminalsPicker"
import * as React from "react"
import { CSSProperties } from "react"

type Props = {
    isSaving: boolean
    applyDisabled: boolean
    onSaveClicked: () => void
}
export const MibSettingsActionButtons = (props: Props) => {
    return (
        <Row style={styles.actionButtonsStickyWrap}>
            <Col span={6}>
                <MibTerminalsMultiselect />
            </Col>
            <Col span={6} offset={12}>
                <div style={styles.saveBtnWrap}>
                    <Button
                        loading={props.isSaving}
                        disabled={props.applyDisabled}
                        className="settings-apply-button"
                        type="primary"
                        onClick={props.onSaveClicked}>
                        {props.isSaving ? "Saving..." : "Apply Settings"}
                    </Button>
                </div>
            </Col>
        </Row>
    )
}

const styles: Record<string, CSSProperties> = {
    actionButtonsStickyWrap: {
        padding: "1rem",
        borderBottom: "1px solid #DFDFDF",
        maxWidth: "55rem",
        position: "fixed",
        top: "calc(10rem + 10px)",
        backgroundColor: "white",
        width: "calc(100% - 19.6rem)",
        zIndex: "100",
    },
    saveBtnWrap: { textAlign: "right" },
}
